import { firestoreDefaultConverter } from 'vuefire'
import { convert } from 'html-to-text'
import type { DocumentData, QueryDocumentSnapshot, SnapshotOptions } from 'firebase/firestore'
import type { DSStory } from '@/types'

export default function converter() {
  const { toDateString } = useDateHelper()

  return {
    toFirestore: firestoreDefaultConverter.toFirestore,
    fromFirestore: (snapshot: QueryDocumentSnapshot<DSStory, DocumentData>, options?: SnapshotOptions) => {
      const data = firestoreDefaultConverter
        .fromFirestore(snapshot, options) as DSStory

      data.shortContent = convert(data.content, {
        limits: {
          maxInputLength: 100,
          ellipsis: '',
        },
        wordwrap: false,
      })
      data.createdDate = toDateString(data.created)
      data.updatedDate = toDateString(data.updated)
      data.author = data.author || '親愛的陌生人'
      data.linkPath = `/stories/${data.id}`

      if (data.imageList?.length > 0)
        data.coverImage = data.imageList[0]

      return data
    },
  }
}
